import { apiGet, apiPost } from './client';
import type {
  ListOrganizationsResult,
  ListParams,
  OrganizationDetail,
  RefreshResult,
} from './types';

// The Teams billing contract (renewal summary, Billing detail, refresh result)
// lives in ./types beside the other admin-monitoring shapes; re-exported here
// so callers of this module need only one import.
export type {
  RefreshResult,
  TeamsBilling,
  TeamsOffer,
  TeamsOfferKind,
  TeamsPrice,
  TeamsRail,
  TeamsRenewalState,
  TeamsRenewalSummary,
  TeamsSubscriptionDetail,
} from './types';

/** GET /admin/organizations — platform-wide teams list. */
export function listOrganizations(
  params: ListParams = {},
): Promise<ListOrganizationsResult> {
  return apiGet<ListOrganizationsResult>('/admin/organizations', params);
}

/** GET /admin/organizations/:orgId — single team detail. */
export function getOrganizationDetail(
  orgId: string,
  params: { windowDays?: number; auditLimit?: number } = {},
): Promise<OrganizationDetail> {
  return apiGet<OrganizationDetail>(
    `/admin/organizations/${encodeURIComponent(orgId)}`,
    params,
  );
}

/**
 * POST /admin/teams-billing/refresh — re-reads every Teams subscription from
 * Apple and Stripe. Sequential on the server, so it can take a while. A second
 * call while one runs is a 409 (ApiError.status).
 */
export function refreshTeamsBilling(): Promise<RefreshResult> {
  return apiPost<RefreshResult>('/admin/teams-billing/refresh');
}
